import { querytimescaleUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const getImmMeasurement = async (
  namespace: string,
  source_id: string,
  signal: AbortSignal,
) => {
  const url = querytimescaleUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/imms/${source_id}/measurement`,
      {
        headers: headers,
        signal: signal,
      },
    );

    return response.data;
  } catch (err) {
    if (signal?.aborted) return;
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to fetch Imm measurement. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while fetching the Imm measurement.",
      );
    }
  }
};
